module.exports = "<div class=\"loader-wrapper\">\n    <div *ngIf=\"show\" class=\"loader\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/loader.component.html
// module id = ../../../../../src/app/common/loader.component.html
// module chunks = main